import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col } from 'antd';
import { usePackage } from './package-context';
import CreatePackage from './CreatePackage';
import ViewUpdateParcel from './UpdateParcel/ViewUpdateParcel';

export default function PackageDecider() {
  const { state } = useLocation();
  const { isResponseDataNull, deviceTypeId } = usePackage();
  const PCL = 3;

  const CreatePackageOnRender = useCallback(
    ({ children }) => isResponseDataNull === true && children,
    [isResponseDataNull]
  );
  const EditPackageOnRender = useCallback(
    ({ children }) => isResponseDataNull === false && children,
    [isResponseDataNull]
  );

  const checkIfPackageExists =
    (state === 'Bl' && deviceTypeId === PCL) ||
    (state === 'Obd' && deviceTypeId < PCL);

  const message =  `Υπάρχει ήδη Ανοιχτό κιβώτιο σε ${state=== 'Bl' && deviceTypeId < PCL ? 'Obd' : 'Bluetooth'}` 
  
    return (
    <>
      <CreatePackageOnRender>
        <CreatePackage />
      </CreatePackageOnRender>
      <EditPackageOnRender>
        {checkIfPackageExists ? (
          <ViewUpdateParcel />
        ) : (
          <Row justify="center">          
            <Col>{message}</Col>
          </Row>
        )}
      </EditPackageOnRender>
    </>
  );
}
